import React from 'react';
import { MapPin, Phone, Mail, Heart } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo-section">
              <img 
                src="https://customer-assets.emergentagent.com/job_aef2aa9d-1a3c-46d3-9c1b-ca1e22440c7e/artifacts/8ly8rinv_Black%20Red%20Bold%20Minimalist%20Racing%20Gear%20Logo%20%282%29.png" 
                alt="Hosechnopf Logo" 
                className="footer-logo"
              />
              <h3 className="footer-brand">Hosechnopf</h3>
              <p className="footer-tagline">Kindermode mit Herz seit 1977</p>
            </div>

            <div className="footer-info">
              <h4 className="footer-heading">Kontakt</h4>
              <div className="contact-items">
                <div className="contact-item">
                  <MapPin size={18} />
                  <span>Rathausgasse 37, 5600 Lenzburg</span>
                </div>
                <div className="contact-item">
                  <Phone size={18} />
                  <span>+41 62 891 59 59</span>
                </div>
                <div className="contact-item">
                  <Mail size={18} />
                  <span>info@hosechnopf-kindermode.ch</span>
                </div>
              </div>
            </div>

            <div className="footer-tradition">
              <h4 className="footer-heading">Unsere Geschichte</h4>
              <p className="tradition-text">
                Seit <strong>1977</strong> sind wir für euch da. Über vier Jahrzehnte haben wir
                Familien begleitet, Kinderaugen zum Leuchten gebracht und hochwertige Mode
                mit Liebe ausgewählt. Nun ist es Zeit, Abschied zu nehmen.
              </p>
              <div className="tradition-years">
                <div className="year-badge">1977</div>
                <div className="year-separator">—</div>
                <div className="year-badge">2025</div>
              </div>
            </div>
          </div>

          <div className="footer-divider"></div>

          <div className="footer-bottom">
            <p className="footer-farewell">
              <Heart size={20} className="heart-icon" />
              <span>
                Danke für 48 wundervolle Jahre. Ihr werdet uns fehlen!
              </span>
              <Heart size={20} className="heart-icon" />
            </p>
            <div className="footer-credits">
              <p className="footer-copyright">
                © 1977-2025 Hosechnopf Kindermode. Alle Rechte vorbehalten.
              </p>
              <a 
                href="https://rockyourpresence.ch/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="creator-link"
              >
                <span>created by</span>
                <img 
                  src="https://customer-assets.emergentagent.com/job_aef2aa9d-1a3c-46d3-9c1b-ca1e22440c7e/artifacts/x77ykhai_RockYourPresecence-Marketingagentur-Lenzburg-logo-horizontal-schwarz-weiss.png" 
                  alt="Rock Your Presence" 
                  className="creator-logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;